import { PaysafeFieldConfig } from './paysafe-field-config.interface';
import { PaysafeFormField } from './paysafe-form-field.enum';

export interface PaysafeCardNumberFieldConfig extends PaysafeFieldConfig {
  fieldName: PaysafeFormField.CardNumber;
  separator: string;
}
